import { authApiService } from '@/api/authApiService';
import { ApiResponseType, AuthResponseType } from '@/types/sharedTypes';

type CheckAuthPinCodePayloadType = {
  pin: string;
};

export const checkAuthPinCodeApi = (data: CheckAuthPinCodePayloadType): Promise<ApiResponseType<AuthResponseType>> => {
  const uri = '/users/auth/pin/';

  return authApiService.POST(uri, data);
};
